'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _components = require('../../components');

var _WhyGenderEqualityFunds = require('./WhyGenderEqualityFunds.css');

var _WhyGenderEqualityFunds2 = _interopRequireDefault(_WhyGenderEqualityFunds);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WhyGenderEqualityFunds = (_dec = (0, _reactCssModules2.default)(_WhyGenderEqualityFunds2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(WhyGenderEqualityFunds, _Component);

  function WhyGenderEqualityFunds(props) {
    (0, _classCallCheck3.default)(this, WhyGenderEqualityFunds);
    return (0, _possibleConstructorReturn3.default)(this, (WhyGenderEqualityFunds.__proto__ || (0, _getPrototypeOf2.default)(WhyGenderEqualityFunds)).call(this, props));
  }

  (0, _createClass3.default)(WhyGenderEqualityFunds, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var bannerImage = 'walking';
      var bannerHeadline = 'Gender Equality in the Workplace';
      var bannerSubtitle = 'What will it take to reach gender equality in the workplace?';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'image-banner' },
          _react2.default.createElement(
            'div',
            { styleName: 'image-banner-container' },
            _react2.default.createElement(
              'div',
              { styleName: 'image-banner-container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'image-banner-' + bannerImage },
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-headline' },
                  bannerHeadline
                ),
                _react2.default.createElement(
                  'div',
                  { styleName: 'image-banner-subtitle' },
                  bannerSubtitle
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'page' },
          _react2.default.createElement(
            'div',
            { styleName: 'container m-b' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(_reactHelmet2.default, { title: 'Gender Equality in the Workplace' }),
              _react2.default.createElement(
                'p',
                null,
                'Women comprise 47% of the workforce, but ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.catalyst.org/research/women-ceos-of-the-sp-500/', title: 'List: Women CEOs of the S&P 500 - Catalyst Research' },
                  'only 4.8%'
                ),
                ' of S&P 500 companies have female CEOs. Men are promoted at ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.wsj.com/articles/its-time-for-companies-to-try-a-new-gender-equality-playbook-1474963861', title: 'It\u2019s Time for Companies to Try a New Gender-Equality Playbook - Wall Street Journal' },
                  '30% higher rates'
                ),
                ' than women during their early career stages. Women are paid 79 cents on the dollar of their male colleagues, and it\u2019s ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.theatlantic.com/business/archive/2016/10/79-cents/504386/', title: 'About Those 79 Cents - The Atlantic' },
                  'even worse'
                ),
                ' for women of color. Fifty percent of ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.pewsocialtrends.org/2018/01/09/women-and-men-in-stem-often-at-odds-over-workplace-equity/', title: 'Women and Men in STEM Often at Odds Over Workplace Equity - Pew Research Center' },
                  'women in STEM fields'
                ),
                ' eventually ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://techcrunch.com/2016/04/14/women-in-tech-whats-the-real-problem/', title: 'https://techcrunch.com/2016/04/14/women-in-tech-whats-the-real-problem/ - TechCrunch' },
                  'leave their job'
                ),
                ' because of hostile work environments. Clearly, we have a long way to go to reach gender equality in the workplace.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'But what will it take to reach gender equality in the workplace?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'According to the United Nations, ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.un.org/womenwatch/osagi/conceptsandefinitions.htm', title: 'Gender Mainstreaming, Concepts and Definitions - United Nations' },
                  'gender equality'
                ),
                ' will be achieved when access to rights, responsibilities or opportunities is unaffected by gender.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'What are some of the top ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.routes.howitworks },
                  'gender equality issues'
                ),
                ' still facing women in the workplace?'
              ),
              _react2.default.createElement(
                'ul',
                { styleName: 'answer-list' },
                _react2.default.createElement(
                  'li',
                  null,
                  'gender balance of companies board of directors, executive staff, senior management, and employee workforce '
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'promotion and career development opportunities'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'commitment to pay a fair wage to all employees '
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'equal access to training and career development'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'non-discriminatory recruitment policy'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'commitment to the safety of employees in the workplace'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'commitment to ensure the protection of human rights'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'initiatives to reduce trafficking and human rights risks throughout the supply chain'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'systems and policies for the reporting of internal ethical compliance complaints without retaliation or retribution'
                )
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null),
          _react2.default.createElement(
            'div',
            { styleName: 'container m-b' },
            _react2.default.createElement(
              'div',
              { styleName: 'container-inner' },
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'How can we move the needle on gender equality in the workplace?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'One strategy is to exert market pressure on companies to improve their performance on gender issues by encouraging individual and institutional investors to ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.aysinvest, title: 'Invest Your Values - As You Sow' },
                  'align their actions with their values,'
                ),
                ' and take responsibility for the investments they own.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'If you want to align your investments with your values, first you have to know what you own. If you\u2019re like most people, though, your investments and retirement plans rely heavily on mutual funds. That makes it nearly impossible to figure out what individual companies you actually own. '
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.ays, title: 'As You Sow' },
                  _react2.default.createElement(
                    'em',
                    null,
                    'As You Sow'
                  )
                ),
                ' is changing that, with its suite of free online ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.aysinvest, title: 'Invest Your Values - As You Sow' },
                  'Invest Your Values'
                ),
                ' tools. Invest Your Values makes it easy to screen mutual fund holdings against specific environmental, social, and governance issues. This transparency gives investors, for the first time, the ability to apply a values lens in evaluating mutual funds.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'em',
                  null,
                  'As You Sow'
                ),
                '\u2019s ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.routes.home },
                  'Gender Equality Funds'
                ),
                ' enables individual and institutional investors to apply a gender lens to portfolios invested through mutual funds and exchange-traded funds (ETFs).'
              ),
              _react2.default.createElement(
                'p',
                null,
                'This tool helps:'
              ),
              _react2.default.createElement(
                'ul',
                { styleName: 'answer-list' },
                _react2.default.createElement(
                  'li',
                  null,
                  'drive capital away from funds that hold companies with poor gender scores.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'drive capital to funds whose holdings reflect positive gender policies and parity.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'exert market pressure on companies to improve their performance on gender issues.'
                )
              ),
              _react2.default.createElement(
                'p',
                null,
                'Gender Equality Funds screens the specific holdings of thousands of the most commonly-held U.S. mutual funds against a database detailing individual company performance on 12 key performance indicators. These 12 indicators combine into an overall Gender Equality Portfolio Score for each mutual fund. The tool is very easy to use\u2014users just type in a fund name or ticker symbol to see the fund\u2019s gender score.'
              ),
              _react2.default.createElement(
                'div',
                { styleName: 'answer-title' },
                'Do I have to sacrifice return when I invest with a gender lens?'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The short answer is no! According to the US SIF Foundation, gender lens investing can generate financial and social returns. In its ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.ussif.org/trends', title: 'US SIF Trends Report - US SIF Foundation' },
                  'report,'
                ),
                ' the foundation tracked data on gender lens investing and identified $868 billion in institutional investor assets under management that take gender lens issues under consideration, more than double the $397 billion identified in 2016.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Research ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://www.catalyst.org/research/women-on-corporate-boards/', title: 'Quick Take: Women on Corporate Boards - Catalyst Research' },
                  'shows'
                ),
                ' that companies with three or more women serving on corporate boards performed significantly better financially than companies with few or no women on their boards. Companies with the highest percentages of women board directors outperformed those with the least number of women, on average, by 53 percent on return on equity, 42 percent for return on sales and 66 percent for return on invested capital.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'So, what are you waiting for? Check out ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.routes.home },
                  'Gender Equality Funds'
                ),
                ' today, visit ',
                _react2.default.createElement(
                  'em',
                  null,
                  'As You Sow'
                ),
                '\u2019s ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.blog, title: 'Gender Equality Blog - As You Sow' },
                  'gender equality blog'
                ),
                ', and ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.signup, title: 'Sign up for updates - Invest You Values' },
                  'sign up'
                ),
                ' for updates.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Gender Equality Funds is ',
                _react2.default.createElement(
                  'em',
                  null,
                  'As You Sow'
                ),
                '\u2019s fifth ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.aysinvest, title: 'Invest Your Values - As You Sow' },
                  'Invest Your Values'
                ),
                ' online tool, joining ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://fossilfreefunds.org', title: '' },
                  'Fossil Free Funds'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://deforestationfreefunds.org', title: '' },
                  'Deforestation Free Funds'
                ),
                ', ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://tobaccofreefunds.org', title: '' },
                  'Tobacco Free Funds'
                ),
                ', and ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: 'https://weaponfreefunds.org', title: '' },
                  'Weapon Free Funds'
                ),
                '. ',
                _react2.default.createElement(
                  _components.Link,
                  { xstrong: true, to: _config2.default.links.signup, title: 'Sign up for updates - Invest You Values' },
                  'Keep up to date'
                ),
                ' on gender equality issues in the workplace.'
              )
            )
          ),
          _react2.default.createElement(_components.GetStartedInput, null)
        )
      );
    }
  }]);
  return WhyGenderEqualityFunds;
}(_react.Component)) || _class);
exports.default = WhyGenderEqualityFunds;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/WhyGenderEqualityFunds/WhyGenderEqualityFunds.js
// module id = 1315
// module chunks = 0